import { render, staticRenderFns } from "./HotelCardFull.vue?vue&type=template&id=0355a908&"
import script from "./HotelCardFull.vue?vue&type=script&lang=js&"
export * from "./HotelCardFull.vue?vue&type=script&lang=js&"
import style0 from "./HotelCardFull.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports